// LIbraires.
import { AxiosPromise } from 'axios';
import { HttpClient } from '@/shared/HttpClient';

// Services.
import { ApiService } from '@/services/base/ApiService';

// Models.
import { Result } from '@/shared/models/Result.model';
import { Message } from '@/shared/models/Message.model';
import { ConditionsGeneralesUtilisation } from '@/models/ConditionsGeneralesUtilisation.model';

/**
 * API service des paramètres de l'application Gesgo.
 */
export default class CguApiService extends ApiService<ConditionsGeneralesUtilisation> {
    /**
     * Constructeur.
     */
    constructor() {
        super('Cgu');
    }

    /**
     * Appel l'API pour récupérer l'unique CGU de l'application.
     * @returns {AxiosPromise<Result<ConditionsGeneralesUtilisation>>} : Une promise axios contenant l'unique objet CGU de l'application.
     */
    public getUniqueCgu(): AxiosPromise<Result<ConditionsGeneralesUtilisation>> {
        return HttpClient.axios.get<Result<ConditionsGeneralesUtilisation>>(`${this.endpoint}`, this.setupAnnulationEtGetConfig());
    }

    /**
     * Mise à jour des conditions générales d'utilisation.
     * @param {ConditionsGeneralesUtilisation} cgu : le CGU à mettre à jour.
     * @returns {AxiosPromise<Result<Message>>} : Une promise axios contenant des messages d'erreurs ou de succès.
     */
    public modifierCgu(cgu: ConditionsGeneralesUtilisation): AxiosPromise<Result<Message>> {
        return HttpClient.axios.put<Result<Message>>(`${this.endpoint}`, cgu, this.setupAnnulationEtGetConfig());
    }
}
